import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-payment-cancel',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslateModule, MatIconModule],
  templateUrl: './dialog-payment-cancel.component.html',
  styleUrl: './dialog-payment-cancel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogPaymentCancelComponent {}
